import React from 'react'
import classnames from 'classnames'
import Icon from '../icon/Icon'

import GaugeChart from '../gaugeChart/GaugeChart'

import './ReportBox.scss'

const ReportBox = ({ drawEmpty, drawEmptyHeight, title, subtitle, showGauge, gaugeValue, gaugeColor, items, boxHeight, className }) => {
  function renderItem (item, index) {
    const isLoading = (typeof item.value === 'undefined')

    const classContainer = classnames('report_box-lvitem', className)
    return (
      <div className={classContainer} key={index}>
        <div className='report_box-lvitem__label'>{item.label}
          {item.tooltip && <Icon className='frontend-p-left-xs-thin' tooltipText={item.tooltip} family='sli' icon='question' />}
        </div>
        <div className='report_box-lvitem__bumper' />
        <div className='report_box-lvitem__value'>
          {isLoading && <span className='is-loading' />}
          {!isLoading && <span>{item.value}</span>}
        </div>
      </div>
    )
  }

  const gaugeProps = {
    minimum: 0,
    maximum: 100,
    data: gaugeValue,
    color: gaugeColor
  }

  const emptyHeightStyle = {
    minHeight: drawEmptyHeight
  }

  const boxStyle = boxHeight ? { minHeight: boxHeight } : {}

  return (
    <div className='report_box' style={boxStyle}>
      {drawEmpty && <div style={emptyHeightStyle} />}
      {!drawEmpty &&
        <div>
          <div className='report_box__header'>
            <div className='report_box__title'>
              <h2>{title}</h2>
              {subtitle &&
                <p className='report_box__subtitle'>{subtitle}</p>}
            </div>
            {showGauge &&
              <div className='report_box__gauge'><GaugeChart {...gaugeProps} /></div>}

          </div>

          {items.map((o, index) => renderItem(o, index))}
        </div>}
    </div>
  )
}

export default ReportBox
